import type { Permission } from '@repo/contracts';

import { APP_ROUTES } from '@/constants/app-routes';

/**
 * The one rule for where a role lands. Every role that can use this app lands
 * on the status page, and one that cannot lands there too and is shown the
 * no-access page, so no two guards can send a person back and forth.
 */
export const homeRouteFor = (_permissions: readonly Permission[]): string => APP_ROUTES.home;
